import type { SampleSizeHelper } from './sampleSizeHelper';

/**
 * Returns an array that gives for each 0-based sample index
 * its start position in bytes from the beginning of the file.
 */
export function buildSampleOffsets(
  sampleSizeHelper: SampleSizeHelper,
  chunkIndexes: number[],
  chunkOffsets: number[],
): number[] {
  const sampleCount = chunkIndexes.length;
  if (sampleCount === 0) {
    return [];
  }
  let lastChunkOffset = -1;
  let currentOffset = -1;

  const sampleOffsets: number[] = [];
  for (let sampleIndex = 0; sampleIndex < sampleCount; sampleIndex++) {
    const chunkIndex = chunkIndexes[sampleIndex];
    const chunkOffset = chunkOffsets[chunkIndex];
    if (chunkOffset !== lastChunkOffset) {
      currentOffset = chunkOffset;
      lastChunkOffset = chunkOffset;
    }

    sampleOffsets[sampleIndex] = currentOffset;
    currentOffset += sampleSizeHelper.getSampleSize(sampleIndex);
  }

  return sampleOffsets;
}
